import React, { ReactElement } from 'react';
import NumericInput from "./NumericInput";

type MoneyInputProps = {
    id: string,
    name?: string,
    label: string,
    required: boolean,
    disabled?: boolean,
    labelContent?: ReactElement,
    children?: React.ReactNode
}

const MoneyInput = (props: MoneyInputProps) => {
    return <NumericInput id={props.id} name={props.name} label={props.label} required={props.required}
                         disabled={props.disabled}
                         labelContent={props.labelContent}
                         inputMask={{ regex: '^[0-9]+(.[0-9]{1,2})?$' }}
                         leftContent={<>$</>} />
};
export default MoneyInput;